/* eslint-disable @next/next/no-css-tags */
import {
  AppInsightsContext,
  MediaGalleryContext,
  MetadataContext,
  ModuleBase,
  TrackEventType,
  useDownloadHub,
  UserContext,
} from '@/components';
import { ImageGroupeModel, ImageModel, ModuleBaseModel, ModuleSectionPropsModel } from '@/types';
import { useContext, useEffect, useState } from 'react';
import MediaGalleryImagesList from './MediaGalleryImagesList/MediaGalleryImagesList';
import Head from 'next/head';

// import title from '../public/legacy/Title.css';

type LegacyReportContentModel = ModuleBaseModel<
  {
    htmlContent: string;
    groupedImages: ImageGroupeModel[];
  } & ModuleSectionPropsModel
>;

const LegacyReportContent = (data: LegacyReportContentModel) => {
  const { htmlContent } = data.props;

  return (
    <>
      <Head>
        <link rel="stylesheet" href="/legacy/ArticleImages.css" />
        <link rel="stylesheet" href="/legacy/Banner.css" />
        <link rel="stylesheet" href="/legacy/ColourBanner.css" />
        <link rel="stylesheet" href="/legacy/ColourStrip.css" />
        <link rel="stylesheet" href="/legacy/ExecutiveSummary.css" />
        <link rel="stylesheet" href="/legacy/Image.css" />
        <link rel="stylesheet" href="/legacy/IPIcons.css" />
        <link rel="stylesheet" href="/legacy/Quote.css" />
        <link rel="stylesheet" href="/legacy/Title.css" />
        <link rel="stylesheet" href="/legacy/TrendEvolution.css" />
        <link rel="stylesheet" href="/legacy/VideoControls.css" />
        <link rel="stylesheet" href="/legacy/Wysiwyg.css" />
      </Head>
      <ModuleBase data={data}>
        <div className="container flex flex-col items-center gap-6">
          <div
            className="w-full lg:w-10/12 [&_.moodboard]:relative [&_.moodboard_div]:overflow-hidden [&_a]:text-[#839dd4]"
            dangerouslySetInnerHTML={{ __html: htmlContent }}
          />
          <MediaGalleryImagesList
            {...{ props: { groupedImages: data.props.groupedImages }, id: '9e161072-717a-4a65-9865-506739eec24f', moduleName: 'MediaGalleryImagesList' }}
          />
        </div>
      </ModuleBase>
    </>
  );
};

export default LegacyReportContent;

/*
const LegacyReportMedia = () => {
  const mediaGalleryContext = useContext(MediaGalleryContext);
  const appInsights = useContext(AppInsightsContext);
  const user = useContext(UserContext);
  const { pageId } = useContext(MetadataContext);
  const [imageList, setImageList] = useState<ImageModel[]>([]);
  const { setDownloadHubGroupedImages } = useDownloadHub();

  useEffect(() => {
    if (user?.isAuthenticated || user?.isIpBasedIdentity) {
      getReportImages();
      addEventsToImages();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.isAuthenticated, user?.isIpBasedIdentity]);

  const getReportImages = () => {
    setImageList([]);
    const imageTagElements = document.querySelectorAll('.imageExtra');
    const newImageList: ImageModel[] = [];
    imageTagElements.forEach((element) => {
      const imageElements = element.getElementsByTagName('img');

      const data: ImageModel = {
        mediaId: -(element.getAttribute('data-imageid') || '0'),
        caption: element.getAttribute('data-title') || '',
        imageUrl: imageElements[0].src,
        imageAlt: '',
        copyrightText: element.getAttribute('data-copyright') || '',
      };

      newImageList.push(data);
    });
    setImageList(newImageList);
    setTimeout(() => {
      setDownloadHubGroupedImages([{ groupName: 'Legacy Report Images', images: newImageList }]);
    }, 1000);
  };

  const addEventsToImages = () => {
    const imageTagElements = document.querySelectorAll('.imageExtra');
    imageTagElements.forEach((element) => {
      const imageElements = element.getElementsByTagName('img');

      const data: ImageModel = {
        mediaId: -(element.getAttribute('data-imageid') || '0'),
        caption: element.getAttribute('data-title') || '',
        imageUrl: imageElements[0].src,
        imageAlt: '',
        copyrightText: element.getAttribute('data-copyright') || '',
      };

      imageElements[0].classList.add('cursor-pointer');
      imageElements[0].addEventListener('click', () => {
        mediaGalleryContext.openMediaGallery(data);
        appInsights.trackGalleryEvent(TrackEventType.OPEN, user, { pageId });
      });

      // TODO scrapbookButton
    });
  };
  return (
    <MediaGalleryImagesList
      legacyImageList={imageList}
      {...{ props: {}, id: '9e161072-717a-4a65-9865-506739eec24f', moduleName: 'MediaGalleryImagesList' }}
    />
  );
};
*/